module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content search"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("search")])]), (_vm.results) ? _c('div', {
    staticClass: "col-8_xs-12 results"
  }, [_c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.loadedData), function(item) {
    return _c('div', {
      staticClass: "col-8_xs-12"
    }, [_c('router-link', {
      attrs: {
        "to": _vm.path(item)
      }
    }, [_c('h2', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(item.title))]), _c('p', {
      staticClass: "h-sxx",
      domProps: {
        "innerHTML": _vm._s(_vm.text(item))
      }
    })])], 1)
  }))]) : _c('div', {
    staticClass: "col-8_xs-12 results"
  }, [_c('h3', {
    staticClass: "sorry h-m"
  }, [_vm._v("Sorry!")]), _c('p', [_vm._v("We couldn't find any results.")])])])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbc743e6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 245
// module chunks = 1